const FRAGMENTS = [
  "Don’t send that yet.",
  "What actually happened?",
  "Okay. Let’s walk it through.",
  "What do the kids need from you right now?",
  "You can feel it without acting on it.",
  "What are you actually trying to fix?",
  "You don’t need to answer that now.",
  "What actually needs dealing with today?",
];

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-ink/10 bg-paper2 py-4 md:py-5"
    aria-hidden="true"
    data-testid="brand-marquee"
  >
    <div className="marquee-track flex w-max whitespace-nowrap font-sans text-sm md:text-base tracking-wide text-ink/50">
      {[0, 1].map((half) => (
        <span key={half} className="flex shrink-0">
          {FRAGMENTS.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="mx-7 md:mx-10">{t}</span>
              <span className="h-1 w-1 rounded-full bg-pine/60" />
            </span>
          ))}
        </span>
      ))}
    </div>
  </div>
);
